import { render, staticRenderFns } from "./DialogCriarCategoria.vue?vue&type=template&id=56a4f95c&scoped=true"
import script from "./DialogCriarCategoria.vue?vue&type=script&lang=js"
export * from "./DialogCriarCategoria.vue?vue&type=script&lang=js"
import style0 from "./DialogCriarCategoria.vue?vue&type=style&index=0&id=56a4f95c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a4f95c",
  null
  
)

export default component.exports